export enum TermsConditionsPositionEnum {
  START = "START",
  END = "END",
}
